import { Brain } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * SpecialNeedsBadge — small, premium badge that surfaces on tutor
 * cards/profiles when the tutor self-declares (or is admin-tagged
 * with) `specialty: 'special_needs'` or `'autism'`.
 *
 * Visual contract:
 *   • soft teal accent — distinct from the "Verified" emerald and
 *     the "Trust Score" indigo so families can recognise it instantly
 *   • icon + bilingual label
 *   • degrades gracefully to icon-only on `size="xs"` cards
 */
export default function SpecialNeedsBadge({ size = 'sm' }) {
  const { localize } = useLanguage();
  const label = localize({
    ar: 'متخصّص في طيف التوحد والاحتياجات الخاصة',
    en: 'Autism & Special-Needs Specialist',
  });
  const compactLabel = localize({ ar: 'تخصّص خاص', en: 'Special needs' });

  if (size === 'xs') {
    return (
      <span
        title={label}
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-teal-100 text-teal-700 ring-1 ring-teal-300"
        data-testid="special-needs-badge-xs"
        aria-label={label}
      >
        <Brain className="w-3 h-3" />
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 ring-1 ring-teal-200 text-[11px] font-bold"
      data-testid="special-needs-badge"
      title={label}
    >
      <Brain className="w-3 h-3" />
      {size === 'sm' ? compactLabel : label}
    </span>
  );
}
